import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addInsights, deleteInsights } from '../../actions';
import AppButton from './AppButton';

class InsightSave extends Component {
    onClick = () => {
        const { collectionId, guid, insights } = this.props;
        const alreadySaved = insights[guid];
        if (alreadySaved) {
            this.props.deleteInsights(guid);
        } else {
            this.props.addInsights(guid, collectionId);
        }
    }
    render() {
        const { insights, guid } = this.props;
        const alreadySaved = insights[guid];
        return (
            <div>
                <AppButton onClick={this.onClick}>{alreadySaved ? 'Delete' : 'Save'}</AppButton>
            </div>
        )
    }
}

InsightSave.propTypes = {
    insights: PropTypes.object,
    guid: PropTypes.string,
    collectionId: PropTypes.any,
    addInsights: PropTypes.func,
    deleteInsights: PropTypes.func,
}

const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        insights: state.insights,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addInsights: bindActionCreators(addInsights, dispatch),
        deleteInsights: bindActionCreators(deleteInsights, dispatch),
        // setAllEpisodesAsPlayed: bindActionCreators(setAllEpisodesAsPlayed, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(InsightSave);
